const calculateReadingTime = (text) => {
	if (!text) return 0;

	const wordsPerMinute = 225;
	const words = text.trim().split(/\s+/).length;
	return Math.max(1, Math.ceil(words / wordsPerMinute));
};

const formatText = (text) => {
	if (!text) {
		console.log('Invalid text provided for formatting.');
		return null;
	}

	const textPatterns = {
		sentenceBreak: /(?<!\d)\.(?=\s[A-ZÅÄÖ])/g, // Split before sentences
		numberedPoint: /(?<=\s|^)(\d+)\.\s/g, // Split before numbered points
		bulletPoints: /(?<=\s|^)([-•])\s/g, // Split before bullet points
		chapterBreak: /\b(Kapitel|Chapter)\s/g, // Split before chapters
		dashWithContent: /(-\s[^\n]+)/g, // Split before dashes with content
	};

	const modifiedText =
		'"' +
		text
			.replace(textPatterns.sentenceBreak, '.|')
			.replace(textPatterns.numberedPoint, '|$1. ')
			.replace(textPatterns.bulletPoints, '|$1 ')
			.replace(textPatterns.chapterBreak, '|$1 ')
			.replace(textPatterns.dashWithContent, (match) => `|${match.replace(/\s(?=\p{Lu})/u, '|\n')}`)
			.trim() +
		'"';

	const formattedText = modifiedText.split('|');

	return formattedText;
};

/*
	Handles citation lists like:
	[1], [1 ], [ 1 ] → [1]
	[5432, position 1], [5432, ] → [5432]
	[5432, 1234], [5432, 1234, 5622] → unchanged (spacing normalized)
	[3fds], [abc] → removed entirely (becomes '')

	Mixed lists like [10, abc, 20] → [10, 20] 
*/
const cleanCitations = (text) => {
	if (!text) return '';

	return text.replace(/\[[^\[\]]*\]/g, (m) => {
		const inner = m.slice(1, -1);
		const references = inner
			.split(',')
			.map((s) => s.trim())
			.filter((s) => /^-?\d+$/.test(s));

		if (references.length === 0) return '';

		return `[${references.join(', ')}]`;
	});
};

export { calculateReadingTime, formatText, cleanCitations };
